import * as React from 'react';
import styles from '@/features/inspection-list/components/styles/inspectionCard.module.scss';
import { Typography, Accordion, AccordionSummary, AccordionDetails, Grid } from '@mui/material';
import { InspectionCardPros } from '@/types/Inspection.type';
import { InspectionCardItem } from '@/features/inspection-list/components/InspectionCardItem.tsx';
import { useTranslation } from 'react-i18next';
import { getProductDisplayText } from '@/utils/inspection.utils';
import { convertToDateFormat } from '@/utils/date.utils';
import { useAppSelector } from '@/store/hooks';
import { InspectUploadStatus } from '@/types/InspectUploadStatus';
import { APP_CONFIG_KEY } from '@/types/AppConfig.type';
import { RootState } from '@/store/rootReducer';
import { useSelector } from 'react-redux';
export const InspectionCard: React.FC<InspectionCardPros> = ({ onToggle, ...inspection }) => {
  const { t } = useTranslation();
  const { toUpload } = useAppSelector((state) => state.uploadProgress);
  const config = useSelector((state: RootState) => state.appConfig);
  return (
    <Accordion className={styles.inspectionCard} expanded={true} onChange={onToggle}>
      <AccordionSummary
        className={styles.inspectionCardSummary}
        // aria-controls={`panel-content-${inspection.id}`}
        // id={`panel-header-${inspection.id}`}
        sx={
          {
            // borderBottom: ".05rem solid #ECECEB",
          }
        }
      >
        <div className={styles.infoContainer}>
          <Grid container direction="column" className={styles.summaryContainer}>
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              sx={{
                borderBottom: '.05rem solid #ECECEB',
              }}
            >
              <Grid size={3}>
                <Typography variant="body2" color="textSecondary">
                  {t((config?.[APP_CONFIG_KEY.useText] as string) || 'Product')} :
                </Typography>{' '}
              </Grid>
              <Grid size={9}>
                {' '}
                <Typography
                  variant="body1"
                  sx={{ fontSize: '0.9rem', color: 'rgba(0, 0, 0, 0.7)' }}
                >
                  {getProductDisplayText(inspection?.product)}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              sx={{ borderBottom: '.05rem solid #ECECEB' }}
            >
              <Grid size={3}>
                <Typography variant="body2" color="textSecondary">
                  {t('Supplier')} :
                </Typography>{' '}
              </Grid>
              <Grid size={9}>
                {' '}
                <Typography
                  variant="body1"
                  sx={{ fontSize: '0.9rem', color: 'rgba(0, 0, 0, 0.7)' }}
                >
                  {inspection.supplier?.name ?? 'Unknown'}
                </Typography>
              </Grid>
            </Grid>
            {config[APP_CONFIG_KEY.showFactory] && (
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                sx={{ borderBottom: '.05rem solid #ECECEB' }}
              >
                <Grid size={3}>
                  <Typography variant="body2" color="textSecondary">
                    {t('Factory')} :
                  </Typography>
                </Grid>
                <Grid size={9}>
                  <Typography
                    variant="body1"
                    sx={{ fontSize: '0.9rem', color: 'rgba(0, 0, 0, 0.7)' }}
                  >
                    {inspection.factory?.name ?? 'Unknown'}
                  </Typography>
                </Grid>
              </Grid>
            )}
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid size={3}>
                <Typography variant="body2" color="textSecondary">
                  {t('inspection_date')} :
                </Typography>{' '}
              </Grid>
              <Grid size={9}>
                {' '}
                <Typography
                  variant="body1"
                  sx={{ fontSize: '0.9rem', color: 'rgba(0, 0, 0, 0.7)' }}
                >
                  {convertToDateFormat(inspection.inspectionDate)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </AccordionSummary>
      <AccordionDetails className={styles.inspectionCardDetails}>
        <div className={styles.expandedContainer}></div>
        {inspection.items
          ?.sort((a, b) => {
            // Get status for each item
            const getItemStatus = (id: string) => {
              const uploadItem = toUpload?.find((i) => i.id === id);
              return uploadItem?.status;
            };

            const statusA = getItemStatus(a.id);
            const statusB = getItemStatus(b.id);

            // Define status priority (higher number = higher priority)
            const statusPriority = {
              [InspectUploadStatus.Failed]: 4,
              [InspectUploadStatus.FailedImages]: 3,
              [InspectUploadStatus.UploadingImages]: 2,
              [InspectUploadStatus.UploadingData]: 2,
              [InspectUploadStatus.Pending]: 1,
              [InspectUploadStatus.Success]: 0,
            };

            // Get priority for each status (default to -1 if not in upload queue)
            const priorityA = statusA ? statusPriority[statusA] : -1;
            const priorityB = statusB ? statusPriority[statusB] : -1;

            // Sort by priority (higher priority comes first)
            return priorityB - priorityA;
          })
          .map((item) => (
            <InspectionCardItem key={item.id} {...item} />
          ))}
      </AccordionDetails>
    </Accordion>
  );
};
